module.exports = __webpack_public_path__ + "img/img4.d4ff1485.jpg";